import * as React from "react"

const ArrowIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="15"
		height="13"
		viewBox="0 0 15 13"
		fill="none">
		<g clipPath="url(#clip0_188_451)">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.6657 5.97278C12.3537 5.6855 11.9914 5.33831 11.6103 4.94627C10.5057 3.8102 9.20094 2.255 8.53846 0.665L9.46154 0.280401C10.0491 1.6905 11.2443 3.13526 12.3272 4.24919C12.8634 4.8007 13.3617 5.26069 13.7257 5.58253C13.9076 5.74332 14.0555 5.86929 14.1574 5.95459C14.2083 5.99723 14.2477 6.02968 14.2741 6.05122L14.3036 6.07523L14.3106 6.08091L14.3122 6.08215L14.8004 6.47273L14.3124 6.8631L14.3106 6.86455L14.3036 6.87024L14.2741 6.89425C14.2477 6.91578 14.2083 6.94823 14.1574 6.99088C14.0555 7.07617 13.9076 7.20214 13.7257 7.36293C13.3617 7.68477 12.8634 8.14476 12.3272 8.69627C11.2443 9.8102 10.0491 11.255 9.46154 12.665L8.53846 12.2804C9.20094 10.6905 10.5057 9.13526 11.6103 7.99919C11.9914 7.60719 12.3537 7.26004 12.6656 6.97278L3.19431e-07 6.97278L2.7572e-07 5.97278L12.6657 5.97278Z"
				fill="white"
				stroke="white"
			/>
		</g>
		<defs>
			<clipPath id="clip0_188_451">
				<rect
					width="13"
					height="15"
					fill="white"
					transform="translate(5.68248e-07 13) rotate(-90)"
				/>
			</clipPath>
		</defs>
	</svg>
)
export default ArrowIcon
